import cn from '@/utils/cn';

interface Props {
  label: string;
  checked: boolean;
  type: 'checkbox' | 'radio';
  onClick: () => void;
}

const PlotOptionCard = ({ label, checked, type, onClick }: Props) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      'flex h-[52px] w-full items-center gap-2.5 rounded-lg border p-4 text-left transition-colors duration-150',
      checked
        ? 'border-green-500 bg-green-50'
        : 'border-gray-500 bg-white hover:border-green-300'
    )}
  >
    {type === 'checkbox' ? (
      <div
        className={cn(
          'flex size-[18px] shrink-0 items-center justify-center rounded border transition-colors duration-150',
          checked
            ? 'border-green-500 bg-green-500'
            : 'border-dark-gray-100 bg-white'
        )}
      >
        {checked && (
          <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
            <path
              d="M1 3.5L3.5 6.5L9 1"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
    ) : (
      <div
        className={cn(
          'size-[18px] shrink-0 rounded-full bg-white transition-colors duration-150',
          checked ? 'border-5 border-green-500' : 'border border-dark-gray-100'
        )}
      />
    )}
    <span
      className={cn(
        'caption-large',
        checked ? 'text-green-500' : 'text-dark-gray-500'
      )}
    >
      {label}
    </span>
  </button>
);

export default PlotOptionCard;
